export default __webpack_public_path__ + "static/media/excel.43f09d4e.png";